var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.4375C11.3797 14.4375 11.6875 14.1297 11.6875 13.75V3.69186L13.228 5.48913C13.4751 5.77741 13.9091 5.8108 14.1974 5.5637C14.4857 5.31659 14.5191 4.88257 14.272 4.59429L11.522 1.38596C11.3914 1.23357 11.2007 1.14587 11 1.14587C10.7993 1.14587 10.6086 1.23357 10.478 1.38596L7.72802 4.59429C7.48092 4.88257 7.51431 5.31659 7.80259 5.5637C8.09088 5.8108 8.5249 5.77741 8.772 5.48913L10.3125 3.69186L10.3125 13.75C10.3125 14.1297 10.6203 14.4375 11 14.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.25004C14.023 8.25004 13.7012 8.25004 13.47 8.40451C13.3699 8.4714 13.2839 8.55735 13.217 8.65746C13.0625 8.88866 13.0625 9.21049 13.0625 9.85417L13.0625 13.75C13.0625 14.8891 12.1391 15.8125 11 15.8125C9.86096 15.8125 8.93755 14.8891 8.93755 13.75V9.85425C8.93755 9.2105 8.93755 8.88862 8.78304 8.65741C8.71617 8.55734 8.63025 8.47141 8.53018 8.40454C8.29897 8.25004 7.97709 8.25004 7.33334 8.25004C4.74062 8.25004 3.44426 8.25004 2.6388 9.0555C1.83334 9.86095 1.83334 11.1571 1.83334 13.7498V14.6665C1.83334 17.2592 1.83334 18.5556 2.6388 19.361C3.44426 20.1665 4.74062 20.1665 7.33334 20.1665H14.6667C17.2594 20.1665 18.5558 20.1665 19.3612 19.361C20.1667 18.5556 20.1667 17.2592 20.1667 14.6665V13.7498C20.1667 11.1571 20.1667 9.86095 19.3612 9.0555C18.5558 8.25004 17.2594 8.25004 14.6667 8.25004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.80380cb79523b6952594bdf089cba414.svg";
export { ForwardRef as ReactComponent };